<template>
  <div class="sky-change-detail">
    <div class="page-content-loading sky-page-detail-content" v-if="loading">
      <sk-icon-status type="ing" content="加载中..."></sk-icon-status>
    </div>
    <div v-else class="sky-page-detail-content">
      <div v-if="monitorDetail.sceneChangeList && monitorDetail.sceneChangeList.length > 0" class="sky-page-content">
        <div>
          <div class="wsp-group-title">
            <div class="wsp-group-title-icon"></div>
            <div class="wsp-group-title-value">场景</div>
            <div class="wsp-group-title-tip"></div>
          </div>
          <div>
            <div>
              <el-table
                :data="monitorDetail.sceneChangeList"
                :border="true"
                row-key="id"
                header-align="center"
                :expand-row-keys="sceneChangeExpandKeys"
                :show-header="true"
                :column-drag-sortable="false"
                class="sk-customize-cell-hight table-content"
              >
                <!-- <el-table-column type="expand" prop="sceneChangeList">
                  <template slot-scope="scope">
                    <change-item-detail :projectId="scope.row.projectId" :specId="scope.row.specId">
                    </change-item-detail>
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="场景名称"
                  prop="specName"
                  header-align="center"
                  show-overflow-tooltip
                  width="300"
                />
                <el-table-column label="操作类型" prop="changeOp" header-align="center" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.changeOp === 'CREATE'" type="success">添加</el-tag>
                    <el-tag v-if="scope.row.changeOp === 'MODIFY'" type="warning">变更</el-tag>
                    <el-tag v-else type="danger">删除</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="变更描述" header-align="center" prop="changeDetailList">
                  <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.changeDetailList.slice(0, 5)" :key="index">
                      {{ item }}
                      <br v-if="index !== 4 && index !== scope.row.changeDetailList.length - 1" />
                      <span v-else-if="index === 4 && scope.row.changeDetailList.length > 5">...更多查看详情</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="变更详情" prop="specId" header-align="center" width="100">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.changeOp !== 'DELETE'"
                      type="text"
                      @click="clickFeatureChangeExpandKeys(scope.row)"
                      class="el-btn-pointer"
                      >查看</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="monitorDetail.featureChangeList && monitorDetail.featureChangeList.length > 0"
        class="sky-page-content"
      >
        <div>
          <div class="wsp-group-title">
            <div class="wsp-group-title-icon"></div>
            <div class="wsp-group-title-value">功能</div>
            <div class="wsp-group-title-tip"></div>
          </div>
          <div>
            <div>
              <el-table
                :data="monitorDetail.featureChangeList"
                :border="true"
                :show-header="true"
                header-align="center"
                row-key="id"
                :column-drag-sortable="false"
                class="sk-customize-cell-hight table-content"
              >
                <el-table-column
                  label="功能名称"
                  prop="specName"
                  header-align="center"
                  show-overflow-tooltip
                  width="250"
                />
                <el-table-column label="操作类型" prop="changeOp" header-align="center" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.changeOp === 'CREATE'" type="success">添加</el-tag>
                    <el-tag v-if="scope.row.changeOp === 'MODIFY'" type="warning">变更</el-tag>
                    <el-tag v-else type="danger">删除</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="变更描述" header-align="center" prop="changeDetailList">
                  <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.changeDetailList.slice(0, 5)" :key="index">
                      {{ item }}
                      <br v-if="index !== 4 && index !== scope.row.changeDetailList.length - 1" />
                      <span v-else-if="index === 4 && scope.row.changeDetailList.length > 5">...更多查看详情</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="变更详情" prop="specId" header-align="center" width="100">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.changeOp !== 'DELETE'"
                      type="text"
                      @click="clickFeatureChangeExpandKeys(scope.row)"
                      class="el-btn-pointer"
                      >查看</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="monitorDetail.caseChangeList && monitorDetail.caseChangeList.length > 0" class="sky-page-content">
        <div>
          <div class="wsp-group-title">
            <div class="wsp-group-title-icon"></div>
            <div class="wsp-group-title-value">用例</div>
            <div class="wsp-group-title-tip"></div>
          </div>
          <div>
            <div>
              <el-table
                :data="monitorDetail.caseChangeList"
                :border="true"
                :show-header="true"
                :column-drag-sortable="false"
                class="sk-customize-cell-hight table-content"
              >
                <el-table-column
                  label="用例名称"
                  prop="specName"
                  header-align="center"
                  show-overflow-tooltip
                  width="300"
                />
                <el-table-column label="用例类型" prop="caseType" header-align="center" width="130">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.caseType === 'BUSINESS'" type="success">功能用例</el-tag>
                    <el-tag v-else-if="scope.row.caseType === 'SOFTWARE'" type="primary">软件用例</el-tag>
                    <el-tag v-else-if="scope.row.caseType === 'PERIPHERAL'" type="warning">外设用例</el-tag>
                    <el-tag v-else type="warning">其他</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作类型" prop="changeOp" header-align="center" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.changeOp === 'CREATE'" type="success">添加</el-tag>
                    <el-tag v-else-if="scope.row.changeOp === 'MODIFY'" type="warning">变更</el-tag>
                    <el-tag v-else type="danger">删除</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="变更描述" header-align="center" prop="changeDetailList">
                  <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.changeDetailList.slice(0, 3)" :key="index">
                      {{ item }}
                      <br v-if="index !== 2 && index !== scope.row.changeDetailList.length - 1" />
                      <span v-else-if="index === 2 && scope.row.changeDetailList.length > 5">...更多查看详情</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="变更详情" header-align="center" prop="specId" width="100">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.changeOp !== 'DELETE'"
                      type="text"
                      @click="clickFeatureChangeExpandKeys(scope.row)"
                      class="el-btn-pointer"
                      >查看
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="monitorDetail.softwareCaseChangeList && monitorDetail.softwareCaseChangeList.length > 0"
        class="sky-page-content"
      >
        <div>
          <div class="wsp-group-title">
            <div class="wsp-group-title-icon"></div>
            <div class="wsp-group-title-value">软件</div>
            <div class="wsp-group-title-tip"></div>
          </div>
          <div>
            <div>
              <el-table
                :data="monitorDetail.softwareCaseChangeList"
                :border="true"
                :show-header="true"
                :column-drag-sortable="false"
                class="sk-customize-cell-hight table-content"
              >
                <!-- <el-table-column type="expand" prop="sceneChangeList">
                  <template slot-scope="scope">
                    <change-item-detail :projectId="scope.row.projectId" :specId="scope.row.specId">
                    </change-item-detail>
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="软件名称"
                  prop="specName"
                  header-align="center"
                  show-overflow-tooltip
                  width="300"
                />

                <el-table-column
                  label="用例名称"
                  prop="specName"
                  header-align="center"
                  show-overflow-tooltip
                  width="300"
                />
                <el-table-column label="用例类型" prop="caseType" header-align="center" width="130">
                  <el-tag type="primary">软件用例</el-tag>
                </el-table-column>
                <el-table-column label="操作类型" prop="changeOp" header-align="center" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.changeOp === 'CREATE'" type="success">添加</el-tag>
                    <el-tag v-else-if="scope.row.changeOp === 'MODIFY'" type="warning">变更</el-tag>
                    <el-tag v-else type="danger">删除</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="变更描述" header-align="center" prop="changeDetailList">
                  <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.changeDetailList.slice(0, 5)" :key="index">
                      {{ item }}
                      <br v-if="index !== 4 && index !== scope.row.changeDetailList.length - 1" />
                      <span v-else-if="index === 4 && scope.row.changeDetailList.length > 5">...更多查看详情</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="变更详情" header-align="center" prop="specId" width="100">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.changeOp !== 'DELETE'"
                      type="text"
                      @click="clickFeatureChangeExpandKeys(scope.row)"
                      class="el-btn-pointer"
                      >查看
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="monitorDetail.peripheralCaseChangeList && monitorDetail.peripheralCaseChangeList.length > 0"
        class="sky-page-content"
      >
        <div>
          <div class="wsp-group-title">
            <div class="wsp-group-title-icon"></div>
            <div class="wsp-group-title-value">外设</div>
            <div class="wsp-group-title-tip"></div>
          </div>
          <div>
            <div>
              <el-table
                :data="monitorDetail.peripheralCaseChangeList"
                :border="true"
                :show-header="true"
                :column-drag-sortable="false"
                class="sk-customize-cell-hight table-content"
              >
                <!-- <el-table-column type="expand" prop="sceneChangeList">
                  <template slot-scope="scope">
                    <change-item-detail :projectId="scope.row.projectId" :specId="scope.row.specId">
                    </change-item-detail>
                  </template>
                </el-table-column> -->
                <el-table-column
                  label="外设名称"
                  prop="specName"
                  header-align="center"
                  show-overflow-tooltip
                  width="300"
                />

                <el-table-column
                  label="用例名称"
                  prop="specName"
                  header-align="center"
                  show-overflow-tooltip
                  width="300"
                />
                <el-table-column label="操作类型" prop="changeOp" header-align="center" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.changeOp === 'ADD'" type="primary">添加</el-tag>
                    <el-tag v-else-if="scope.row.changeOp === 'MODIFY'" type="warning">变更</el-tag>
                    <el-tag v-else type="danger">删除</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="变更描述" header-align="center" prop="changeDetailList">
                  <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.changeDetailList.slice(0, 5)" :key="index">
                      {{ item }}
                      <br v-if="index !== 4 && index !== scope.row.changeDetailList.length - 1" />
                      <span v-else-if="index === 4 && scope.row.changeDetailList.length > 5">...更多查看详情</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="变更详情" prop="specId" header-align="center" width="100">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.changeOp !== 'DELETE'"
                      type="text"
                      @click="clickFeatureChangeExpandKeys(scope.row)"
                      class="el-btn-pointer"
                      >查看</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="monitorDetail.terminalList && terminalList.length > 0" class="sky-page-content">
        <div>
          <div class="wsp-group-title">
            <div class="wsp-group-title-icon"></div>
            <div class="wsp-group-title-value">推荐终端</div>
            <div class="wsp-group-title-tip"></div>
          </div>
          <div>
            <div class="wsp-display-flex wsp-margin-top-12">
              <div class="wsp-width-100">
                <el-table
                  ref="terminal_rl_poc"
                  :data="terminalList"
                  :border="true"
                  :show-header="true"
                  header-align="center"
                  :column-drag-sortable="false"
                  @select="selectTerminal"
                  @select-all="selectAllTerminal"
                  style="width: 100%"
                >
                  <el-table-column type="selection" header-align="center" width="55"> </el-table-column>
                  <el-table-column prop="model" label="型号" header-align="center" width="180">
                    <template slot-scope="scope">
                      <div class="wsp-display-flex">
                        <div>{{ scope.row.model }}</div>
                        <div v-if="scope.row.hasRecommend === false">
                          <el-tooltip
                            class="box-item"
                            effect="dark"
                            :content="scope.row.notRecommendDesc"
                            placement="right"
                          >
                            <div class="el-icon-warning bg-red" style="padding-left: 5px;"></div>
                          </el-tooltip>
                        </div>
                      </div> </template
                  ></el-table-column>
                  <el-table-column
                    prop="typeDesc"
                    header-align="center"
                    label="客户端类型"
                    width="100"
                    show-overflow-tooltip
                  />
                  <el-table-column prop="cpuInfo" header-align="center" label="CPU" show-overflow-tooltip />
                  <el-table-column prop="memoryInfo" header-align="center" label="内存信息(GB)" />
                  <el-table-column prop="diskInfo" header-align="center" label="硬盘信息(GB)" />
                  <el-table-column prop="sceneName" header-align="center" label="场景名称" show-overflow-tooltip />
                  <el-table-column prop="sourceFrom" header-align="center" label="来源" width="120">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.sourceFrom === 'CUSTOMER_ENV'" type="primary">客户环境</el-tag>
                      <el-tag v-else-if="scope.row.sourceFrom === 'SCENE'" type="success">场景推荐</el-tag>
                      <el-tag v-else-if="scope.row.sourceFrom === 'MANUALLY_ADD'" type="danger">手工添加</el-tag>
                      <el-tag v-else type="warning">未知来源</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="monitorDetail.serverList && serverList.length > 0" class="sky-page-content">
        <div>
          <div class="wsp-group-title">
            <div class="wsp-group-title-icon"></div>
            <div class="wsp-group-title-value">推荐服务器</div>
            <div class="wsp-group-title-tip"></div>
          </div>
          <div>
            <div class="wsp-display-flex wsp-margin-top-12">
              <div class="wsp-width-100">
                <el-table
                  ref="scene_rl_server"
                  :data="serverList"
                  :show-header="true"
                  :border="true"
                  header-align="center"
                  :column-drag-sortable="false"
                  @select="selectServer"
                  @select-all="selectAllServer"
                  style="width: 100%"
                  :key="reloadTable"
                >
                  <el-table-column type="selection" width="55" header-align="center" :selectable="selectable">
                  </el-table-column>
                  <el-table-column
                    prop="serverName"
                    label="服务器型号"
                    header-align="center"
                    width="200"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    :label="$t('pocMng.server.cpu')"
                    width="350"
                    prop="cpuConfigId"
                    header-align="center"
                    class-name="full-value-content"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-select
                        style="width: 100%;"
                        v-if="scope.row.sourceType !== 'ThirdServer'"
                        v-model="scope.row.cpuConfigId"
                        first
                        class="full-content"
                      >
                        <el-option
                          v-for="item in scope.row.specServerConfigDTOList"
                          :key="item.id"
                          :label="item.configValueOne"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <div v-else>{{ scope.row.cpuInfo }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="GPU"
                    width="140"
                    prop="gpuConfigId"
                    class-name="full-value-content"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-select
                        style="width: 100%;"
                        v-if="scope.row.sourceType !== 'ThirdServer' && scope.row.gpuConfigDTOList"
                        v-model="scope.row.gpuConfigId"
                        first
                        class="full-content"
                      >
                        <el-option
                          v-for="item in scope.row.gpuConfigDTOList"
                          :key="item.id"
                          :label="`${item.configValueOne} ${item.configValueTwo}`"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <div v-else>{{ scope.row.gpu }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="服务器类型"
                    prop="type"
                    header-align="center"
                    show-overflow-tooltip
                    width="160"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.type === 'VDI'">三擎服务器</div>
                      <div v-else-if="scope.row.type === 'IDV'">纯TCI/IDV服务器</div>
                      <div v-else-if="scope.row.type === 'MINI'">MINI服务器</div>
                      <div v-else>第三方服务器</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="memoryInfo" header-align="center" label="内存(GB)" />
                  <el-table-column prop="diskInfo" header-align="center" label="磁盘大小(GB)" />
                  <el-table-column prop="sourceFrom" header-align="center" label="来源" width="120">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.sourceFrom === 'CUSTOMER_ENV'" type="primary">客户环境</el-tag>
                      <el-tag v-else-if="scope.row.sourceFrom === 'SCENE'" type="success">场景推荐</el-tag>
                      <el-tag v-else-if="scope.row.sourceFrom === 'MANUALLY_ADD'" type="danger">手工添加</el-tag>
                      <el-tag v-else type="warning">未知来源</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sky-change-detail-buttom" style="text-align: center;">
      <el-button
        type="primary"
        class="sky-branch-pattern__add"
        icon="sk-icon-home"
        @click="gotoHomePocProjectList"
        style="margin-top:5px"
      >
        我的项目
      </el-button>
      <el-button
        :loading="saving"
        type="success"
        class="sky-branch-pattern__add"
        style="margin-top:5px"
        @click="onConfirm"
      >
        我已知晓并确认
      </el-button>
    </div>
  </div>
</template>
<script>
import { Button, Card, Table, TableColumn, Tag, Select, Option } from 'element-ui'

import { SkIconStatus } from 'sk-ui'
import { action } from 'sky-engine/api'

import ChangeItemDetail from './ChangeItemDetail'

import { PROJECT_MONITOR, POC_MNG } from '@/api/apiModules'

import { getProjectMonitorChangeDetail } from '@/api/project'
import { getServerDetail } from '@/api/server'
export default {
  name: 'SkyChangeDetail',
  components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [SkIconStatus.name]: SkIconStatus
    // ChangeItemDetail
  },
  props: {
    projectId: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      monitorDetail: null,
      loading: true,
      thirdServerId: null,
      terminalList: [],
      serverList: [],
      haveVDITerminal: false,
      sceneChangeExpandKeys: [],
      terminalSpecIdArr: [],
      thirdTerminalIdArr: [],
      reloadTable: false,
      featureChangeExpandKeys: [],
      selectCalcServer: {},
      saving: false
    }
  },
  created() {},
  mounted() {
    getProjectMonitorChangeDetail({ id: this.projectId })
      .then(res => {
        this.loading = false
        this.monitorDetail = res.data.content
        this.terminalList = []
        //终端
        if (res.data.content.terminalList) {
          this.terminalList = res.data.content.terminalList
        }
        //第三方终端
        if (res.data.content.thirdTerminalList) {
          for (const iterator of res.data.content.thirdTerminalList) {
            iterator.sourceType = 'ThirdTerminal'
            this.terminalList.push(iterator)
          }
        }
        //锐捷服务器
        if (res.data.content.serverList) {
          var idvArr = this.terminalList.filter(item => {
            item.isDisabled = item.hasOutputTestPlan
            return item.hasOutputTestPlan && item.type === 'VDI'
          })
          for (const iterator of res.data.content.serverList) {
            if (idvArr.length > 0 && iterator.type === 'IDV') {
              iterator.enableSelect = false
              iterator.hasOutputTestPlan = false
            } else {
              iterator.enableSelect = true
            }
            getServerDetail({ id: iterator.serverId, severConfigKey: 'GPU' }).then(res => {
              iterator.gpuConfigDTOList = res.data.content.specServerConfigDTOList
            })
            this.serverList.push(iterator)
          }
        }

        //第三方服务器
        if (res.data.content.thirdServerList) {
          for (const iterator of res.data.content.thirdServerList) {
            iterator.enableSelect = true
            ;(iterator.cpuInfo = iterator.cpuTotalThreads),
              (iterator.memoryInfo = iterator.memory),
              (iterator.sourceType = 'ThirdServer'),
              this.serverList.push(iterator)
          }
        }
        this.$nextTick(() => {
          for (const iterator of this.terminalList) {
            if (iterator.hasOutputTestPlan) {
              this.$refs.terminal_rl_poc.toggleRowSelection(iterator)
            }
          }
          for (const iterator of this.serverList) {
            if (iterator.hasOutputTestPlan) {
              this.$refs.scene_rl_server.toggleRowSelection(iterator)
            }
          }
          this.checkIsHavVdiTerminal()
        })
      })
      .catch(e => {
        this.loading = false
        throw e
      })
  },
  methods: {
    gotoHomePocProjectList() {
      action(POC_MNG, 'deleteLock')
        .then(response => {})
        .catch(e => {
          throw e
        })
      this.activiteViewPage = null
      this.$store.dispatch('ReturnPage')
      this.$emit('cb')
    },
    clickFeatureChangeExpandKeys(row, column, event) {
      var dialog = this.$dialog({
        template: h => {
          const projectId = row.projectId
          var specId = row.specId
          return (
            <change-item-detail
              projectId={projectId}
              specId={specId}
              onCb={function() {
                dialog.remove()
                dialog.component.$parent.$parent.reloadData()
              }}
            ></change-item-detail>
          )
        },
        components: {
          ChangeItemDetail
        },
        props: {
          title: '变更明细',
          width: '75%',
          'custom-class': 'custom-change-detail-dialog',
          showCancelBtn: false, // 隐藏取消按钮
          showClose: true, // 隐藏关闭按钮
          showDefaultFooter: true, //隐藏确定和取消按钮
          closeOnPressEscape: false, // 不能通过ESC键关闭
          closeOnHashChange: false // 不能通过路由改变关闭
        }
      })
    },
    clickSceneChangeExpandKeys(row, column, event) {
      this.sceneChangeExpandKeys = []
      this.sceneChangeExpandKeys.push(row.id)
    },
    showChangeItemDetail(specId) {},
    checkIsHavVdiTerminal() {
      this.haveVDITerminal = false
    },
    selectable(row, index) {
      return true
    },
    selectAllTerminal() {
      for (const iterator of this.terminalList) {
        iterator.hasOutputTestPlan = true
      }
      //this.reloadServerTableChangeEnableSelect()
    },
    selectTerminal(selection, row) {
      const exists = selection.some(obj => obj.terminalId === row.terminalId && obj.sceneId === row.sceneId)
      row.hasOutputTestPlan = exists
      //this.reloadServerTableChangeEnableSelect()
    },
    reloadServerTableChangeEnableSelect() {
      var enableIDVServer = true
      for (const iterator of this.terminalList) {
        if ('VDI' === iterator.type && iterator.hasOutputTestPlan === true) {
          enableIDVServer = false
          if (this.selectCalcServer && this.selectCalcServer.type == 'IDV') {
            this.selectCalcServer = {}
          }
        }
      }
      this.hasVDITerminal = !enableIDVServer
      if (!enableIDVServer) {
        for (const serverItem of this.serverList) {
          if (serverItem.type === 'IDV') {
            serverItem.enableSelect = false
            serverItem.hasOutputTestPlan = false
          } else {
            serverItem.enableSelect = true
            serverItem.isDisabled = false
          }
        }
      } else {
        for (const serverItem of this.serverList) {
          serverItem.enableSelect = true
        }
      }
      this.reloadTable = !this.reloadTable

      this.$nextTick(() => {
        if (this.selectCalcServer) {
          this.$refs.scene_rl_server.toggleRowSelection(this.selectCalcServer)
        } else {
          this.$refs.scene_rl_server.clearSelection()
          this.selectCalcServer = Object.assign({}, this.selectCalcServer, {})
        }
      })
    },
    selectAllServer(selectArr) {
      if (selectArr.length > 0) {
        // 处理全部选中的情况
        for (const iterator of this.serverList) {
          iterator.hasOutputTestPlan = true
          if (iterator.sourceType !== 'ThirdServer') {
            if (iterator.specServerConfigDTOList && !iterator.cpuConfigId) {
              iterator.select = iterator.specServerConfigDTOList[0]
              iterator.cpuConfigId = iterator.select.id
            }
          }
        }
      } else {
        // 处理全部不选中的情况
        for (const iterator of this.serverList) {
          iterator.hasOutputTestPlan = false
          iterator.cpuConfigId = null
        }
      }
    },
    selectServer(selectArr, row) {
      if (!row) {
        return
      }
      if (selectArr.length === 0) {
        this.selectCalcServer = []
        for (const iterator of this.serverList) {
          iterator.hasOutputTestPlan = false
        }
      }
      const exists = selectArr.some(obj => obj.serverId === row.serverId && obj.sceneId === row.sceneId)
      if (exists) {
        row.hasOutputTestPlan = true
      } else {
        row.hasOutputTestPlan = false
        row.cpuConfigId = null
      }

      if (row.sourceType !== 'ThirdServer') {
        if (row.specServerConfigDTOList && !row.cpuConfigId) {
          row.select = row.specServerConfigDTOList[0]
          row.cpuConfigId = row.select.id
        }
      }
    },
    onConfirm() {
      if (this.terminalList.length > 0) {
        var isSelectedTerminal = false
        this.terminalList.forEach(item => {
          if (item.hasOutputTestPlan) {
            isSelectedTerminal = true
            if (item.sourceType != 'ThirdTerminal') {
              this.terminalSpecIdArr.push(item.terminalId)
            } else {
              this.thirdTerminalIdArr.push(item.id)
            }
          }
        })
        if (!isSelectedTerminal) {
          this.$store.dispatch('OpenNotification', { message: '请至少选择一种终端', type: 'error' })
          return
        }
      }
      var request = {}
      if (this.serverList.length > 0) {
        var isSelectedServer = false
        var isSelectedCpu = true
        this.serverList.forEach(item => {
          if (item.hasOutputTestPlan) {
            isSelectedServer = true
            if (!item.cpuConfigId) {
              isSelectedCpu = false
            }
          }
        })
        if (!isSelectedServer) {
          this.$store.dispatch('OpenNotification', { message: '请至少选择一种服务器', type: 'error' })
          return
        }
        if (!isSelectedCpu) {
          this.$store.dispatch('OpenNotification', { message: '服务器请选择CPU', type: 'error' })
          return
        }
        var thirdServerList = []
        var selectedServerList = []
        this.serverList.forEach(item => {
          if (item.hasOutputTestPlan) {
            if (item.sourceType === 'ThirdServer') {
              thirdServerList.push(item.id)
            } else {
              var server = {
                serverId: item.serverId,
                cpuConfigId: item.cpuConfigId,
                gpuConfigId: item.gpuConfigId
              }
              selectedServerList.push(server)
            }
          }
        })

        request = {
          projectId: this.projectId,
          thirdTerminalIdArr: this.thirdTerminalIdArr,
          terminalSpecIdArr: this.terminalSpecIdArr,
          ruijieServerList: selectedServerList,
          thirdServerList: thirdServerList
        }
      } else {
        request = {
          projectId: this.projectId,
          thirdTerminalIdArr: this.thirdTerminalIdArr,
          terminalSpecIdArr: this.terminalSpecIdArr
        }
      }
      this.saving = true
      action(PROJECT_MONITOR, 'change/updateProjectInst', request)
        .then(response => {
          this.$emit('cb')
          this.$store.dispatch('OpenNotification', { message: '项目更新成功', type: 'success' })
          //todo 重新加载页面数据
          //this.$parent.$parent.$parent.getData()
          this.$emit('reloadData')
          this.saving = false
        })
        .catch(e => {
          throw e
        })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(change-detail) {
  height: 80vh;

  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #cccccc;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #999999;
  }
  .page-content-loading {
    padding-left: 20px;
    padding-top: 20px;
  }
  .sky-page-detail-content {
    overflow-y: scroll;
    height: 75vh;
  }
  .table-content {
    max-height: 408px;
    overflow-y: scroll;
    .el-table__expanded-cell {
      padding: 0px !important;
    }
  }
  .el-table__body-wrapper .full-value-content {
    padding: 0 !important;
  }
  .el-table__body-wrapper .full-value-content .cell {
    padding: 0 !important;
    min-height: 33px !important;
    .full-content {
      width: 100%;
      height: 100%;
    }
  }
  .el-btn-pointer {
    cursor: pointer;
  }
  .page-content-item {
    padding-left: 18px;
  }
  .poc-scene-research-content {
    .scene-item {
      .scene-item-name {
        line-height: 28px;
        border-radius: 6px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        padding: 2px 18px;
      }
    }
  }
  .sky-change-detail-buttom {
    position: absolute;
    bottom: 12px;
    height: 88px;
    left: 50%;
    transform: translate(-50%, 50%);
  }
  .poc-base-detail-content {
    line-height: 28px;
    .base-detail-attr-item div {
      display: inline-block;
    }
    .base-detail-attr-item .attr-label {
      text-align: right;
    }
  }
}
</style>
